import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRiveLoader } from '@/composables/useRiveLoader';
import { useInstance } from '@/composables/useInstance';

// Dedicated component so useRiveLoader's onMounted/onBeforeUnmount lifecycle
// runs on every show/hide of the loader overlay (it sits under a v-if).

export default /*#__PURE__*/_defineComponent({
  __name: 'PreloadedIframeRiveLoader',
  setup(__props) {

const { $vuetify } = useInstance();
const size = computed(() => ($vuetify.breakpoint.smAndDown ? 120 : 164));

const { riveCanvas, canvasWidth, canvasHeight } = useRiveLoader({
  width: size,
  height: size,
});

return { __sfc: true,$vuetify, size, riveCanvas, canvasWidth, canvasHeight }
}

})